import DataTableStatic from 'components/organisms/data-table-static'
import customerOrderShipmentTableColumns from 'domains/customer-order/molecules/shipment-table-columns'
import PropTypes from 'prop-types'
import React, { useMemo, useCallback } from 'react'
import { useHistory } from 'react-router'

const propTypes = {
  data: PropTypes.array
}

const defaultProps = {
  data: []
}

/**
 * @param {Array<Object>} data - array of orders shipments objects
 */
const CustomerOrderShipmentListTable = ({
  data
}) => {
  const history = useHistory()

  const handleSelectRow = useCallback((datum) => {
    const id = datum.id
    history.push({
      pathname: `shipments/${id}`
    })
  }, [ history ])

  /**
   * It's important that we're using React.useMemo
   * here to ensure that our data isn't recreated on every render.
   * see https://react-table.tanstack.com/docs/quick-start
   *  */
  const columns = useMemo(() => customerOrderShipmentTableColumns(handleSelectRow), [ handleSelectRow ])

  if (data.length < 1) return null
  return (
    <DataTableStatic
      data={ data }
      columns={ columns }
    />
  )
}

CustomerOrderShipmentListTable.propTypes    = propTypes
CustomerOrderShipmentListTable.defaultProps = defaultProps

export default CustomerOrderShipmentListTable
